module.exports = __webpack_public_path__ + "img/11087938_L.48641698.png";